import { api } from "./base";

export const getSettings = async ({ locale }) => {
  api.defaults.headers = { locale };
  const res = await api.get("/settings");
  return res.data;
};
